<template>
  <SuperAdminShell>
    <div class="super-admin-page">
      <header class="super-admin-page__header">
        <div class="super-admin-page__header-lead">
          <h3>{{ Number(typeSystem) === 2 ? 'Criar empresa — Personalizar Weflix' : 'Criar empresa — Site e portal' }}</h3>
          <small>
            {{ companyName || (Number(typeSystem) === 2 ? 'Configure a loja Weflix para entrega' : 'Configure a loja para entrega') }}
          </small>
        </div>
        <div class="super-admin-page__header-actions">
          <button
            type="button"
            class="btnSave btnFillPreview"
            @click="fillStep2Preview"
            :disabled="fillingPreview"
          >
            <span v-if="!fillingPreview">Preencher dados</span>
            <span v-else>Gerando imagens...</span>
          </button>
          <button
            type="button"
            class="btnSave btnCancel"
            @click="$router.push(companyId ? `/editar-empresa/${companyId}` : '/admin/empresas')"
          >
            Voltar para edição
          </button>
        </div>
      </header>
      <div class="super-admin-page__shell">
        <div class="super-admin-page__panel">
          <CompanyStep2Form
            ref="step2Form"
            v-if="companyId"
            :company-id="companyId"
            :type-system="typeSystem"
            :type-business="typeBusiness"
            :representative-id="representativeId"
            :redirect-on-save="false"
            :show-fill-preview="false"
            finalize-label="Finalizar"
            @step-change="onStepChange"
            @saved="onStep2Saved"
          />
        </div>
      </div>
    </div>
  </SuperAdminShell>
</template>

<script>
import SuperAdminShell from '@/Views/Weflix/SuperAdminShell.vue'
import CompanyStep2Form from '@/components/Weflix/SuperAdmin/CompanyStep2Form.vue'
import { mapState } from 'vuex'
import { toast } from 'vue3-toastify'
import superAdmin from '@/utils/superAdmin'
import { applySuperAdminBranding } from '@/utils/superAdmin/branding'

export default {
  components: {
    SuperAdminShell,
    CompanyStep2Form,
  },
  data() {
    return {
      loadedTypeSystem: null,
      loadedTypeBusiness: null,
      loadedRepresentativeId: null,
      loadedCompanyName: null,
      fillingPreview: false,
      stepProgress: '',
    }
  },
  computed: {
    ...mapState(['token', 'currentCompanyCreated']),
    companyId() {
      return this.$route.params.slug || this.currentCompanyCreated?.company?.id
    },
    typeSystem() {
      return this.loadedTypeSystem
        ?? this.currentCompanyCreated?.company?.typeSystem
        ?? 1
    },
    typeBusiness() {
      return this.loadedTypeBusiness
        ?? this.currentCompanyCreated?.company?.typeBusiness
        ?? null
    },
    representativeId() {
      return this.loadedRepresentativeId
        ?? this.currentCompanyCreated?.representative?.id
        ?? null
    },
    companyName() {
      return this.loadedCompanyName
        || this.currentCompanyCreated?.company?.name
        || this.currentCompanyCreated?.company?.tradeName
    },
  },
  methods: {
    onStepChange(payload) {
      this.stepProgress = payload?.progressLabel
        ? `${payload.progressLabel} · ${payload.label}`
        : ''
    },
    onStep2Saved() {
      const id = this.companyId
      if (id) {
        this.$router.push(`/editar-empresa/${id}`)
        return
      }
      toast.success('Layout da empresa salvo com sucesso.')
    },
    async fillStep2Preview() {
      if (!this.$refs.step2Form?.fillPreviewData || this.fillingPreview) return
      this.fillingPreview = true
      try {
        await this.$refs.step2Form.fillPreviewData()
      } finally {
        this.fillingPreview = false
      }
    },
    async loadCompanyMeta() {
      if (!this.companyId || !this.token) return
      try {
        const response = await superAdmin.createCompanyById(this.token, this.companyId)
        this.loadedTypeSystem = response?.typeSystem ?? null
        this.loadedTypeBusiness = response?.typeBusiness ?? null
        this.loadedCompanyName = response?.name || response?.tradeName || null
        this.loadedRepresentativeId = response?.representative?.id
          || response?.idRepresentative
          || response?.representativeId
          || null
      } catch (error) {
        console.error('Erro ao carregar empresa no step 2:', error)
      }
    },
  },
  mounted() {
    applySuperAdminBranding()
    this.loadCompanyMeta()
  },
}
</script>
